import { Button, ButtonGroup } from "@chakra-ui/react"
import { useMemo } from "react"
import { BsFileMinus } from "react-icons/bs"
import { itemData, AL_DISCLAIM, useSelectedItemAlertContext } from "../../context/selectedItemAlertContext"

const TableButtonDisclaimQueue = ({ row, size = "xs" }) => {
    const { setItemData } = useSelectedItemAlertContext()
    const enableButton = useMemo(() => {
        //console.log(row.original?.queue_status_id)
        return row.original?.queue_status_id === 1 || row.original?.queue_status_id === 2
    }, [row])
    const actionHandle = (row) => {
        if (enableButton) {
            const header = `คิวลำดับที่ ${row.order}`
            const body = `คิวลำดับที่ ${row.order} ${row.residence_name}`
            setItemData(itemData(row.id, AL_DISCLAIM, header, body))
        }
    }

    return (
        <ButtonGroup spacing={2} size={size}>
            <Button leftIcon={<BsFileMinus />} colorScheme="red" onClick={() => actionHandle(row.original)} isDisabled={!enableButton}>สละสิทธิ</Button>
        </ButtonGroup>
    )
}

export default TableButtonDisclaimQueue